import React from 'react';
import { rgb } from 'constants/types';
import propTypes from 'prop-types';

import ColorBullet from 'common/ColorBullet';
import WarningIcon from 'common/WarningIcon';
import classNames from 'classnames';

const cellBaseString = `vra-review-scenarios-zone-cell`;

const ZoneRow = (row) => {
  const trClassName = classNames({
    'vra-review-scenarios-zone-row': true,
    'clickableRecommendationZones': true,
    isSelected: row.isSelected
  });
  return (<tr className={trClassName} onClick={() => (
    Boolean(row.onClickRow) ? row.onClickRow(row.zoneInternalId, row.isSelected) : false
  )}>
    <td className={`${cellBaseString}--name`}>
      <ColorBullet className={`${cellBaseString}--bullet`} color={row.color} />
      <span className={`${cellBaseString}--name`}>{row.name}</span>
    </td>
    <td className={`${cellBaseString}--rate`}>{row.rateText}</td>
    <td className={`${cellBaseString}--average-yield`}>{row.averageYieldText}</td>
    <td className={`${cellBaseString}--area`}>
      {row.areaText}
      {row.isDeadZone && <WarningIcon /> }
    </td>
  </tr>);};


ZoneRow.propTypes = {
  row:propTypes.shape({
    color: rgb.isRequired,
    name: propTypes.string.isRequired,
    onClickRow: propTypes.func,
    rateText: propTypes.string.isRequired,
    rate: propTypes.number,
    averageYieldText: propTypes.string.isRequired,
    averageYield: propTypes.number,
    areaText: propTypes.string.isRequired,
    area: propTypes.number,
    isDeadZone: propTypes.bool,
    isSelected: propTypes.bool
  })
};

export default ZoneRow;
